/**
 * Vendored from react-text-annotate v0.3.0 (https://github.com/mcamac/react-text-annotate)
 * MIT License — Copyright (c) 2018 Martin Camacho.
 *
 * Vendored because upstream is unmaintained (no react-17-compatible release;
 * its react ^16 peer was the last blocker to plain `npm install` in this
 * repo). Only the TokenAnnotator path is kept; TextAnnotator is dropped.
 * Behavior is unchanged, except lodash.sortby is replaced by a native stable
 * sort (Array.prototype.sort is spec-stable since ES2019).
 */

export const splitTokensWithOffsets = (tokens, offsets) => {
  let lastEnd = 0;
  const splits = [];

  for (const offset of [...offsets].sort((a, b) => a.start - b.start)) {
    const { start, end } = offset;
    if (lastEnd < start) {
      for (let i = lastEnd; i < start; i++) {
        splits.push({ i, content: tokens[i] });
      }
    }
    splits.push({
      ...offset,
      mark: true,
      content: tokens.slice(start, end).join(' ')
    });
    lastEnd = end;
  }

  for (let i = lastEnd; i < tokens.length; i++) {
    splits.push({ i, content: tokens[i] });
  }

  return splits;
};

export const selectionIsEmpty = (selection) => {
  const position = selection.anchorNode.compareDocumentPosition(selection.focusNode);
  return position === 0 && selection.focusOffset === selection.anchorOffset;
};

export const selectionIsBackwards = (selection) => {
  if (selectionIsEmpty(selection)) return false;

  const position = selection.anchorNode.compareDocumentPosition(selection.focusNode);

  let backward = false;
  if (
    (!position && selection.anchorOffset > selection.focusOffset) ||
    position === Node.DOCUMENT_POSITION_PRECEDING
  ) {
    backward = true;
  }

  return backward;
};
